/**
 * `isProductionEnv()` — the single "is this a production build" check.
 *
 * Do NOT use `process.env.REACT_APP_ENV`: it is not defined in any env file or
 * in the deployed prod bundle, so it is always `undefined`. `NODE_ENV` is no
 * good either — `react-scripts build` sets it to 'production' for stage and QA.
 * The API host and the Clerk key prefix are the only markers that differ.
 */

const PRODUCTION_API_HOST = 'api.cadencepro.ai';
const PRODUCTION_CLERK_KEY_PREFIX = 'pk_live_';

const getApiHost = (): string => {
  try {
    return new URL(process.env.REACT_APP_API_BASE_URL || '').hostname.toLowerCase();
  } catch (error) {
    return '';
  }
};

const usesLiveClerkInstance = (): boolean =>
  (process.env.REACT_APP_CLERK_PUBLISHABLE_KEY || '').startsWith(PRODUCTION_CLERK_KEY_PREFIX);

export const isProductionEnv = (): boolean =>
  getApiHost() === PRODUCTION_API_HOST || usesLiveClerkInstance();
